<ng-container *ngIf="referenceSizeState$ | async as state">

    <div class="reference-container mat-elevation-z8">
        <div class="table-header">
            <mat-form-field subscriptSizing="dynamic">
                <input matInput #filter (keyup)="applyFilter($event.target.value)" placeholder="Filter">
                <button *ngIf="filter.value"
                        mat-icon-button
                        matSuffix
                        aria-label="clear"
                        color="primary"
                        (click)="filter.value=''; applyFilter('');">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>

            <button mat-mini-fab
                    color="primary"
                    matTooltip="{{ 'app.page.reference-size.actions.add.label' | translate }}"
                    (click)="onOpenDialog()">
                <mat-icon>add</mat-icon>
            </button>
        </div>
        <mat-progress-bar color="accent" [style.visibility]="state.loading ? 'visible' : 'hidden'" mode="indeterminate"></mat-progress-bar>
        <div class="table-container">
            <table mat-table [dataSource]="dataSource" matSort>

                <ng-container matColumnDef="name">
                    <th mat-header-cell mat-sort-header
                        *matHeaderCellDef>{{ "app.model.reference-size.bezugsgroesse_bezeichnung.label" | translate}}</th>
                    <td mat-cell *matCellDef="let element">
                        {{element.name}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="measure-unit-name">
                    <th mat-header-cell *matHeaderCellDef>{{ "app.model.reference-size.masseinheit.label" | translate}}</th>
                    <td mat-cell *matCellDef="let element">
                        {{state.measureUnits[element.measureId].name}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="edit-button">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element" class="actions-column">
                        <button mat-icon-button
                                color="primary"
                                matTooltip="{{ 'app.page.reference-size.actions.edit.label' | translate }}"
                                (click)="onOpenDialog(element)">
                            <mat-icon>edit</mat-icon>
                        </button>
                        <button mat-icon-button
                                color="warn"
                                matTooltip="{{ 'app.page.reference-size.actions.delete.label' | translate }}"
                                (click)="onDeleteReference(element)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </td>
                </ng-container>


                <tr mat-header-row *matHeaderRowDef="state.columns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: state.columns;"></tr>
            </table>
            <mat-paginator showFirstLastButtons [pageSizeOptions]="[20, 50]"></mat-paginator>
        </div>
    </div>


</ng-container>
